import { jsx as l } from "react/jsx-runtime";
import { S as g } from "./chunks/index.CCavb-1K.js";
import "@smart/web-foundations";
import { c as b } from "./chunks/index.rKuIKazb.js";
import v from "react";
import { L as x } from "./chunks/layout.BROMuy9M.js";
import './assets/text.css';const _ = {
  "cap-100": "_cap-100_7ewq3_3",
  "cap-200": "_cap-200_7ewq3_64",
  "cap-300": "_cap-300_7ewq3_125",
  "cap-400": "_cap-400_7ewq3_186",
  "d-300": "_d-300_7ewq3_247",
  "d-200": "_d-200_7ewq3_308",
  "d-100": "_d-100_7ewq3_369",
  "hl-300": "_hl-300_7ewq3_430",
  "hl-200": "_hl-200_7ewq3_491",
  "hl-100": "_hl-100_7ewq3_552",
  "hl-50": "_hl-50_7ewq3_613",
  "hyp-200": "_hyp-200_7ewq3_674",
  "hyp-100": "_hyp-100_7ewq3_742",
  "hyp-lgl": "_hyp-lgl_7ewq3_810",
  "lbl-200": "_lbl-200_7ewq3_878",
  "lbl-100": "_lbl-100_7ewq3_939",
  "lgl-100": "_lgl-100_7ewq3_1000",
  "link-100": "_link-100_7ewq3_1061",
  "p-300": "_p-300_7ewq3_1122",
  "p-200": "_p-200_7ewq3_1183",
  "p-100": "_p-100_7ewq3_1244",
  "overflow-wrap-normal": "_overflow-wrap-normal_7ewq3_1305",
  "overflow-wrap-anywhere": "_overflow-wrap-anywhere_7ewq3_1308",
  "overflow-wrap-break-word": "_overflow-wrap-break-word_7ewq3_1311"
}, k = v.forwardRef(
  ({
    children: w,
    className: r,
    variant: a = "p-100",
    overflowWrap: e = "normal",
    as: o = "span",
    asChild: p,
    ...t
  }, s) => {
    const q = b(
      _.text,
      _[a],
      {
        [_[`overflow-wrap-${e}`]]: e
      },
      r
    ), c = p ? g : o, { padding: h, color: m, width: d, height: n, display: i, margin: f, ...y } = t;
    return /* @__PURE__ */ l(
      x,
      {
        padding: h,
        display: i,
        color: m,
        width: d,
        height: n,
        margin: f,
        asChild: !0,
        children: /* @__PURE__ */ l(c, { ...y, ref: s, className: q, children: w })
      }
    );
  }
);
k.displayName = "Text";
export {
  k as Text
};
//# sourceMappingURL=text.js.map
